let geojsonLayer = {};
let dataSourceObj = {};

function addGeojsonLayer (layerinfo, viewer) {
  const promise = Cesium.GeoJsonDataSource.load(layerinfo.data, {clampToGround: true});
  promise.then(function(dataSource) {
    viewer.dataSources.add(dataSource);
    var entities = dataSource.entities.values;
    for (var i = 0; i < entities.length; i++) {
      var entity = entities[i];
      entity.name = 'geojson';
      if (layerinfo.showType === 'point') {
        entity.billboard = undefined;
        entity.point = new Cesium.PointGraphics({
          color: Cesium.Color.fromCssColorString(entity.properties.color._value),
          pixelSize: entity.properties.radius._value
        });
        entity.label = new Cesium.LabelGraphics({
          text: entity.properties.text._value,
          font: 'bolder 8px sans-serif',
          style: Cesium.LabelStyle.FILL_AND_OUTLINE,
          pixelOffset: new Cesium.Cartesian2(0, 15),
          outlineWidth: 10,
        })
      } else {
        entity.description = layerinfo.fcode;
        entity.properties.color = layerinfo.strokeColor;
        entity.polygon.fill = true;
        entity.polygon.outline = true;
        entity.polygon.material = Cesium.Color.fromCssColorString(layerinfo.strokeColor);
        entity.polygon.outlineColor = Cesium.Color.fromCssColorString(layerinfo.strokeColor);
        entity.polygon.outlineWidth = 3;
        entity.polygon.height = 1;
        entity.polygon.extrudedHeight = 0.1;
        entity.polygon.heightReference = Cesium.HeightReference.RELATIVE_TO_GROUND;
      }
    }
    geojsonLayer[layerinfo.fcode] = entity;
    dataSourceObj[layerinfo.fcode] = dataSource;
  })
}

function setGeojsonLayerStyle (id, style) {
  if (geojsonLayer[id]) {
    if (style.hasOwnProperty("outlineColor")) {
      geojsonLayer[id].polygon.outlineColor = Cesium.Color.fromCssColorString(style.outlineColor);
    }
  }
}

function removeGeojsonLayer (layerinfo, viewer) {
  if (layerinfo.hasOwnProperty("removeAll")) {
    viewer.dataSources.removeAll();
    geojsonLayer = {};
    dataSourceObj = {};
  } else {
    viewer.dataSources.remove(dataSourceObj[layerinfo.fcode]);
    delete dataSourceObj[layerinfo.fcode];
    delete geojsonLayer[layerinfo.fcode];
  }
}

export { addGeojsonLayer, removeGeojsonLayer, setGeojsonLayerStyle }
